module.exports = __webpack_public_path__ + "img/stethoscope.f7fb6692.svg";